<template>
    <div class="main-width">
        <div class="list">
            <slot name="sort">
                <filter-sort-bar :initSort="initSort" :sorts="sorts" :initSortType="initSortType"
                    :count="listData.total_count || 0" :selectType="selectType" />
            </slot>
            <!--置顶推荐-->
            <section class="top_list_wrapper" v-if="listData.top_list && listData.top_list.length">
              <div class="top_flag">推荐</div>
              <div v-for="item in listData.top_list" :key="item.id">
                    <slot name="item" :info="item">
                        <product-item  :loading="loading" :info="item" @view-trip="handleViewTrip(item)"  @view-date="handleViewTravelDate(item)" />
                    </slot>
                </div>
            </section>
            <div v-for="item in listData.list" :key="item.id">
                <slot name="item" :info="item">
                    <product-item :loading="loading" :info="item" @view-trip="handleViewTrip(item)"  @view-date="handleViewTravelDate(item)" />
                </slot>
            </div>
            <no-result v-if="listData.list && listData.list.length == 0">
                <template #title>目前没有满足所有筛选项的产品，请尝试放大筛选范围</template>
            </no-result>
        </div>
        <div class="pagation" v-if="listData.list && listData.list.length">
            <div class="total">共{{ listData.total_count || 0 }}条</div>
            <Pagination background layout="prev, pager, next, jumper, slot" :total="listData.total_count || 0"
                :page="page_index" @current-change="onPageChange" prev-text='上一页' next-text="下一页">
            </Pagination>
        </div>
        <!--查看产品出发日期--->
		<ProductDatesDialog v-if="isOpenViewTravelDate" :visible.sync="isOpenViewTravelDate" :product_no="viewTravelDateState.product_no"></ProductDatesDialog>
        <CruiseTripDialog v-if="isOpenViewTrip" :visible.sync="isOpenViewTrip" :title="viewTripState.title"
						:product_no="viewTripState.product_no" />
    </div>
</template>
<script>
import { ref,reactive } from '@nuxtjs/composition-api';
import NoResult from "@/views/product/components/ListNoResult";
import FilterSortBar from "@/components/product/filterSortBar.vue";
import ProductItem from './prodcutItem.vue'
import Pagination from "../VPagination";
import scrollToTop from '@/utils/scrollToTop'
import ProductDatesDialog from '@/components/product/product-dates-dialog.vue';
import CruiseTripDialog from '@/components/product/cruise-trip-dialog.vue';


export default {
    props: {
        listData: {
            type: Object,
            default: () => ({
                list: [],
                total_count: 0
            })
        },
        loading: {
            type: Boolean,
            default: false
        },
        initSort: {
            type: Array,
            default: () => (['1'])
        },
        initSortType: {
            type: String,
            default: ''
        },
        selectType: {
            validator(value) {
                return ['single', 'multiple'].includes(value)
            },
            default: 'single'
        },
        sorts: {
            type: Array,
        },
        pageIndex: {
            type: Number,
            default: 1
        }
    },
    components: {
        ProductItem,
        NoResult,
        FilterSortBar,
        Pagination,
        ProductDatesDialog,
        CruiseTripDialog
    },
    setup(props){
        const page_index = ref(props.pageIndex || 1)
        const page_size = ref(10)
        const sort_name = ref(null)
        const sort_type = ref(null)


		// ======================= 查看出游日期 =======================
		const isOpenViewTravelDate = ref(false);
		const viewTravelDateState = reactive({
			product_no: '',
		})
		const handleViewTravelDate = async (product) => {
			isOpenViewTravelDate.value = true;
			console.log(product);
			viewTravelDateState.product_no = product.product_no;
		}


        // ======================= 查看行程 =======================
		const isOpenViewTrip = ref(false);
		const viewTripState = reactive({
			title: '',
			product_no: '',
			// tours: []
		})
		const handleViewTrip = async (product) => {
			isOpenViewTrip.value = true;
			viewTripState.title = product.name;
			viewTripState.product_no = product.product_no;
		}

        return {
            page_index,
            page_size,
            sort_name,
            sort_type,
            isOpenViewTravelDate,
			viewTravelDateState,
			handleViewTravelDate,

            isOpenViewTrip,
			viewTripState,
			handleViewTrip,
        }
    },
    methods: {
        sortChange(val, sort_type) {
            this.sort_name = val;
            this.sort_type = sort_type
            this.page_index = 1
            const query = {
                page_index: this.page_index,
                page_size: this.page_size,
                sort_name: this.sort_name,
                sort_type: this.sort_type,
            }
            this.$emit('change', query)
        },
        onPageChange(val) {
            console.log('onPageChange',val)
            this.page_index = val;
            let query = {}
            if (!this.$slots.sort) {
                query = {
                    page_index: this.page_index,
                    page_size: this.page_size,
                    sort_name: this.$route.query.sort_name || this.initSort[0],
                    sort_type: this.$route.query.sort_type || this.initSortType,
                }
            } else {
                query = {
                    page_index: this.page_index,
                    page_size: this.page_size,
                }
            }

            scrollToTop()
            this.$emit('change', query)
        }
    },
    watch: {
        pageIndex: {
            handler(val) {
                this.page_index = val
            }
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
.main-width .list {
  background-color: #fff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}
.main-width .list .top_list_wrapper {
  position: relative;
  border: 2px solid #FE862D;
  padding-top: 36px;
  padding-bottom: 17px;
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.1);
}
.main-width .list .top_list_wrapper .top_flag {
  position: absolute;
  top: 0px;
  left: 0px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 57px;
  height: 34px;
  line-height: 34px;
  background-color: #FE862D;
  border-radius: 0 0 10px 0;
  font-size: 20px;
  font-weight: 500;
}
.main-width .list .top_list_wrapper ::v-deep .goods:last-child {
  border-bottom: none;
}
.main-width .pagation {
  height: 64px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
}
.main-width .pagation .total {
  font-size: 16px;
  color: $color-black-2;
}
.main-width .pagation ::v-deep .el-pager li, .main-width .pagation ::v-deep .v-pager li {
  height: 32px;
  min-width: 32px;
  line-height: 32px;
  font-size: 14px;
  background-color: #fff;
  border-radius: 2px;
  border: 1px solid #dcdcdc !important;
  font-weight: normal;
  margin: 0 4px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.main-width .pagation ::v-deep .el-pager li.active, .main-width .pagation ::v-deep .v-pager li.v-pager-num-active {
  border: 1px solid $color-black-2 !important;
  background-color: #fff;
  color: $color-black-2;
  font-weight: 700;
}
.main-width .pagation ::v-deep .btn-prev, .main-width .pagation ::v-deep .btn-next {
  height: 32px;
  width: 82px;
  line-height: 32px;
  background-color: #fff;
  border: 1px solid #dcdcdc !important;
  font-weight: normal;
  margin: 0 4px;
}
.main-width .pagation ::v-deep .btn-prev span, .main-width .pagation ::v-deep .btn-next span {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.main-width .pagation ::v-deep .btn-prev:disabled, .main-width .pagation ::v-deep .btn-next:disabled {
  border: 1px solid #dcdcdc !important;
  cursor: not-allowed;
}
.main-width .pagation ::v-deep .btn-prev:disabled span, .main-width .pagation ::v-deep .btn-next:disabled span {
  color: #BFBFBF;
}
.main-width .pagation ::v-deep .v-pagination-jump {
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  font-size: 14px;
  height: 32px;
  line-height: 32px;
}
.main-width .pagation ::v-deep .v-pagination-jump .el-input__inner {
  border-color: #dcdcdc;
  height: 32px;
  border-radius: 2px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.main-width .pagation ::v-deep .jump {
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  font-weight: normal;
}
.main-width .pagation ::v-deep .jump .jump-input {
  border-color: #dcdcdc;
  height: 32px;
  border-radius: 2px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
</style>
